// https://app.growthbook.io/features/mccerts-1928-secondary-cta-removal
export const MCCERTS_1928_SECONDARY_CTA_REMOVAL_FLAG =
  'mccerts-1928-secondary-cta-removal'

export type SecondaryCtaRemovalVariables = {
  certificateImages: Record<string, string>
}
